import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router'
import IntroToWorkspaceModal from '../modals/IntroToWorkspaceModal'; 

class WorkspacesPortal extends Component {
  render() {

    // Container ref
    let targetContainer = document.getElementById('react-workspaces-container');
    
    // Dont load if container doesnt exist
    if (targetContainer === null){
        return null;
    }

    return ReactDOM.createPortal(
      <Router>
        <IntroToWorkspaceModal />
      </Router>, targetContainer
    );
  }
}

export default WorkspacesPortal;